const AVERAGE_RATING_GLOBAL_NAME = '__FESMELACTA_AVERAGE_RATING__';

function normalizeAverageRating(rating) {
  if (!rating) {
    return null;
  }

  const ratingValue = Number(rating.ratingValue);
  const ratingCount = Number(rating.ratingCount);

  if (
    !Number.isFinite(ratingValue) ||
    !Number.isFinite(ratingCount) ||
    ratingValue < 1 ||
    ratingValue > 5 ||
    ratingCount < 1
  ) {
    return null;
  }

  return {
    ratingValue,
    ratingCount,
  };
}

function calculateAverageRating(rows = []) {
  const ratings = rows
    .map((row) => (Array.isArray(row) ? row[0] : row))
    .map((value) => Number.parseInt(value, 10))
    .filter((rating) => rating >= 1 && rating <= 5);

  if (ratings.length === 0) {
    return null;
  }

  const average = ratings.reduce((sum, rating) => sum + rating, 0) / ratings.length;

  return {
    ratingValue: Math.round(average * 10) / 10,
    ratingCount: ratings.length,
  };
}

function buildAverageRatingCachePayload({ rating, generatedAt = new Date().toISOString() } = {}) {
  return Object.assign(
    {},
    normalizeAverageRating(rating) || { ratingValue: null, ratingCount: 0 },
    { generatedAt },
  );
}

function buildAverageRatingCacheScript({ rating, generatedAt } = {}) {
  const payload = buildAverageRatingCachePayload({ rating, generatedAt });
  const safeJson = JSON.stringify(payload).replace(/</g, '\\u003c');

  return `window.${AVERAGE_RATING_GLOBAL_NAME}=${safeJson};\n`;
}

module.exports = {
  AVERAGE_RATING_GLOBAL_NAME,
  buildAverageRatingCachePayload,
  buildAverageRatingCacheScript,
  calculateAverageRating,
  normalizeAverageRating,
};
